import { stringify } from "./stringify";

export const normalize = (value: any) => stringify(value);
